import { render, staticRenderFns } from "./SF.vue?vue&type=template&id=5b300b7c&scoped=true&"
var script = {}
import style0 from "./SF.vue?vue&type=style&index=0&id=5b300b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b300b7c",
  null
  
)

export default component.exports